import { create } from 'zustand';
import { User } from 'firebase/auth';
import { auth } from '../../lib/firebase';
import { clearCachedOrganization } from '../../stores/useOrganizationStore';

interface AuthState {
  user: User | null;
  loading: boolean;
  role: string | null;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setRole: (role: string | null) => void;
  signOut: () => Promise<void>;
}

// Helper to check if we should ignore persisted user
const shouldIgnorePersistedUser = () => {
  const isResetFlow = sessionStorage.getItem('passwordResetFlow') === 'true';
  const isResetPage = window.location.href.includes('__/auth/action');
  return isResetFlow || isResetPage;
};

// Get persisted user if available and not in reset flow
const initialUser = shouldIgnorePersistedUser() ? null : auth.currentUser;

export const useAuthStore = create<AuthState>((set) => ({
  user: initialUser,
  loading: true,
  role: null,
  setUser: (user) => {
    if (!user) {
      set({ user: null, role: null });
    } else {
      set({ user });
    }
  },
  setLoading: (loading) => set({ loading }),
  setRole: (role) => set({ role }),
  signOut: async () => {
    await auth.signOut();
    clearCachedOrganization();
    set({ user: null, role: null });
  },
}));
